import { gql } from '../__generated__';

export const MARK_ACTION_AS_NOT_INTERESTED = gql(`
    mutation MarkActionAsNotInterested($contactId: String!) {
      update_Contacts_by_pk(pk_columns: {id: $contactId}, _set: {priorityScore: -1, userSetAsNotInterestedAt: "now()"}) {
          id
      }
    }
`);

export const UNDO_MARK_ACTION_AS_NOT_INTERESTED = gql(`
    mutation UndoMarkActionAsNotInterested($contactId: String!) {
      update_Contacts_by_pk(pk_columns: {id: $contactId}, _set: {priorityScore: -1, userSetAsNotInterestedAt: null}) {
          id
      }
    }
`);

export const MARK_ACTION_AS_COMPLETED = gql(`
    mutation MarkActionAsCompleted($contactId: String!) {
      update_Contacts_by_pk(pk_columns: {id: $contactId}, _set: {lastCompletedActionAt: "now()"}) {
        id
      }
}
`);

export const UPDATE_SAMPLE_CONTACT_CONVERSATION = gql(`
    mutation UpdateSampleContactConversation($id: String!, $conversation: jsonb!) {
      update_SampleContacts_by_pk(pk_columns: {id: $id}, _set: {conversation: $conversation}) {
        id
        conversation
        updatedAt
      }
    }
`);

export const CREATE_SAMPLE_CONTACT = gql(`
    mutation CreateSampleContact($contact: jsonb!, $conversation: jsonb) {
      insert_SampleContacts_one(object: {contact: $contact, conversation: $conversation}) {
        id
        contact
        conversation
        createdAt
        updatedAt
      }
    }
`);

export const DELETE_SAMPLE_CONTACT = gql(`
    mutation DeleteSampleContact($id: String!) {
      delete_SampleContacts_by_pk(id: $id) {
        id
      }
    }
`);

export const SNOOZE_ACTION = gql(`
    mutation SnoozeAction($contactId: String!, $snoozedUntil: timestamp!) {
      update_Contacts_by_pk(pk_columns: {id: $contactId}, _set: {snoozedUntil: $snoozedUntil}) {
        id
      }
    }
`);

export const SNOOZE_ACTION_BY_PROSPECT_ID = gql(`
    mutation SnoozeActionByProspectId($prospectId: String!, $snoozedUntil: timestamp!) {
      update_Contacts(where: {prospectId: {_eq: $prospectId}}, _set: {snoozedUntil: $snoozedUntil}) {
        affected_rows
      }
    }
`);

export const INSERT_MESSAGE_DRAFT = gql(`
    mutation InsertMessageDraft(
        $userId: String!
        $organizationId: String!
        $contactId: String!
        $prospectId: String
        $source: String!
        $content: String!
        $subjectLine: String!
        $channelType: ChannelType!
        $userPrompt: String!
    ) {
        insert_MessageDrafts_one(
            object: {
                userId: $userId
                organizationId: $organizationId
                contactId: $contactId
                prospectId: $prospectId
                source: $source
                content: $content
                subjectLine: $subjectLine
                channelType: $channelType
                userPrompt: $userPrompt
            }
        ) {
            id
            content
            subjectLine
        }
    }
`);

export const UPDATE_MESSAGE_DRAFT = gql(`
    mutation UpdateMessageDraft(
        $id: String!
        $content: String!
        $subjectLine: String!
        $channelType: ChannelType!
        $userPrompt: String!
    ) {
        update_MessageDrafts_by_pk(
            pk_columns: { id: $id }
            _set: {
                content: $content
                subjectLine: $subjectLine
                channelType: $channelType
                userPrompt: $userPrompt
            }
        ) {
            id
            content
            subjectLine
        }
    }
`);

export const ARCHIVE_MESSAGE_DRAFTS = gql(`
    mutation ArchiveMessageDrafts($userId: String!, $contactId: String!) {
        update_MessageDrafts(
            where: {
                userId: { _eq: $userId }
                contactId: { _eq: $contactId }
                archivedAt: { _is_null: true }
            }
            _set: {
                archivedAt: "now()"
            }
        ) {
            affected_rows
            returning {
                id
                source
                content
                subjectLine
                archivedAt
            }
        }
    }
`);

export const CREATE_CONTACTS_INTERACTIONS = gql(`
    mutation CreateContactsInteractions($userId: String!, $organizationId: String!, $contactId: String!, $contactMetadata: jsonb!, $weights: jsonb!, $interactionType: ContactInteractionType!) {
      insert_ContactsInteractions_one(object: {userId: $userId, organizationId: $organizationId, contactId: $contactId, metadata: $contactMetadata, weights: $weights, interactionType: $interactionType}) {
        id
      }
    }
`);

export const CREATE_SEARCH_RESULT_INTERACTIONS = gql(`
    mutation CreateSearchResultInteractions($userId: String!, $organizationId: String!, $metadata: jsonb!, $weights: jsonb!, $interactionType: ContactInteractionType!) {
      insert_ContactsInteractions_one(object: {userId: $userId, organizationId: $organizationId, metadata: $metadata, weights: $weights, interactionType: $interactionType}) {
        id
      }
    }
`);

export const UPDATE_CONTACT_TYPE = gql(`
    mutation UpdateContactType($contactId: String!, $contactType: String!) {
        update_Contacts_by_pk(
            pk_columns: {id: $contactId}, 
            _append: {metadata: {contactType: $contactType}}
        ) {
            id
            metadata
            contactType: metadata(path: "contactType")
        }
    }
`);
